import { Howl } from 'howler';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AnalyticsEventUtil from '../../../../infra/analytics/analytics-event-util';
import { disableMusic, selectIsMusicEnabled, selectSoundtrack, selectSoundtrackVolume } from '../../../../store/selectors/global.selector';
import { AppState } from '../../../../store/store';

const MusicPlayer = () => {
  const [howl, setHowl] = useState<Howl | null>(null);
  const isPlaying = useSelector(selectIsMusicEnabled);
  const soundtrack = useSelector(selectSoundtrack);
  const soundtrackVolume = useSelector(selectSoundtrackVolume);
  const interacted = useSelector((state: AppState) => state.global.hasInteracted);
  const dispatch = useDispatch();

  useEffect(() => {
    if (soundtrack != null) {
      const howlObj = new Howl({
        src: [soundtrack],
        loop: true,
        volume: soundtrackVolume,
      });
      setHowl((prev) => {
        prev?.stop();
        prev?.unload();
        return howlObj;
      });
    }
  }, [soundtrack]);

  useEffect(() => {
    howl?.volume(soundtrackVolume);
  }, [howl, isPlaying, soundtrackVolume]);

  useEffect(() => {
    if (interacted) {
      if (isPlaying) {
        AnalyticsEventUtil.getInstance().musicEnabled();
        howl?.play();
      } else {
        AnalyticsEventUtil.getInstance().musicDisabled();
        dispatch(disableMusic());
        howl?.pause();
      }
    } else {
      dispatch(disableMusic());
    }
  }, [isPlaying, dispatch, soundtrack, interacted, howl]);

  if (!soundtrack) {
    return null;
  }

  return null;
};

export default MusicPlayer;
